"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormInputEmail = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactUforms = require("react-uforms");

var _utils = require("../../../utils");

var _const = require("../../../const");

var _box = require("../../box");

var _text = require("../../text");

var _link = require("../../link");

var _input = require("./input.styled");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormInputEmail = function FormInputEmail(props) {
  var name = props.name,
      id = props.id,
      _props$type = props.type,
      type = _props$type === void 0 ? 'email' : _props$type,
      disabled = props.disabled,
      required = props.required,
      measure = props.measure,
      placeholder = props.placeholder,
      _onChange = props.onChange,
      min = props.min,
      max = props.max,
      suggestion = props.suggestion,
      step = props.step,
      hideError = props.hideError,
      _onBlur = props.onBlur,
      onFocus = props.onFocus;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      suggestionDomains = _useState2[0],
      setSuggestionDomains = _useState2[1];

  var handleChange = function handleChange(value) {
    if ((0, _utils.validateEmail)(value)) {
      var _value$split = value.split('@', 2),
          _value$split2 = _slicedToArray(_value$split, 2),
          emailName = _value$split2[0],
          emailDomain = _value$split2[1];

      var sd = _const.emailDomains.reduce(function (accumulator, ed) {
        if (accumulator.length === 0) {
          var score = (0, _utils.levenshtein)(ed, emailDomain, {});

          if (score < 4) {
            accumulator.push({
              domainSuggestion: ed,
              email: {
                name: emailName,
                domain: emailDomain
              },
              score: score
            });
          }
        }

        return accumulator;
      }, []);

      setSuggestionDomains(sd);
    } else {
      setSuggestionDomains([]);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_reactUforms.CustomField, {
    name: name,
    hideError: hideError
  }, function (_ref) {
    var setValue = _ref.setValue,
        setTouched = _ref.setTouched;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_input.FormInputStyled, {
      name: name,
      id: id,
      type: type,
      disabled: disabled,
      required: required,
      measure: measure,
      placeholder: placeholder,
      onChange: _onChange,
      min: min,
      max: max,
      step: step,
      ["type"]: "email",
      ["id"]: id,
      ["name"]: name,
      ["onChange"]: function onChange(event) {
        var newValue = event.target.value;
        setValue(newValue);
        handleChange(newValue);
        _onChange === null || _onChange === void 0 ? void 0 : _onChange(event);
      },
      onBlur: function onBlur(event) {
        event.persist();
        setTouched();
        _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(event);
      },
      onFocus: onFocus,
      ["placeholder"]: placeholder,
      hideError: hideError
    }), suggestion && suggestionDomains.length > 0 && suggestionDomains[0].score > 0 && /*#__PURE__*/_react.default.createElement(_box.Box, {
      mt: 8
    }, /*#__PURE__*/_react.default.createElement(_link.A, {
      underline: false,
      measure: "xs",
      fontWeight: "light",
      onClick: function onClick() {
        var correctEmail = "".concat(suggestionDomains[0].email.name, "@").concat(suggestionDomains[0].domainSuggestion);
        setValue(correctEmail);
        setSuggestionDomains([]);
      }
    }, "Maybe you mean", /*#__PURE__*/_react.default.createElement(_text.Text, {
      as: "span",
      color: "success",
      measure: "xs",
      fontWeight: "light",
      ml: 3,
      mr: 3
    }, "".concat(suggestionDomains[0].email.name, "@").concat(suggestionDomains[0].domainSuggestion)), "?")));
  });
};

exports.FormInputEmail = FormInputEmail;
FormInputEmail.defaultProps = {
  measure: 'md',
  disabled: false,
  required: false,
  hideError: true,
  placeholder: 'Enter'
};